/**
 * Lo comun a los chips de estado que van encima de las tablas: cada chip
 * agrupa unos estados, lleva su color y sirve de filtro al tocarlo.
 *
 * Cada pantalla define sus propios chips porque no comparten ni los estados
 * ni el campo donde viven: las postulaciones usan "estado" y los jurados
 * "status".
 */

export interface ChipEstado {
  clave: string;
  etiqueta: string;
  /** Los estados que agrupa. null significa "todo, sin filtrar". */
  estados: string[] | null;
  /** Clase de color del chip, la misma que tenia cada contador. */
  clase: string;
  /** Clase de color del numero. */
  claseNumero: string;
  /** El color del chip, para el borde y el fondo cuando esta encendido. */
  color: string;
}

/** Gris de los chips que no tienen un color propio. */
export const NEUTRO = "#4B4B4B";

/**
 * El mismo color con transparencia, para el fondo del chip encendido.
 * Los navegadores entienden el hexadecimal de ocho digitos.
 */
export const colorDeFondo = (color: string): string => `${color}1F`;

/** Los registros que le corresponden a un chip. */
export const filtrarPorChip = (
  registros: any[],
  chips: ChipEstado[],
  clave: string | null | undefined,
  campo: string
): any[] => {
  const lista = registros ?? [];
  const chip = chips.find((uno) => uno.clave === clave) ?? null;
  // Sin chip, o con una clave desconocida, no se esconde nada.
  if (!chip || chip.estados === null) return lista;
  return lista.filter((registro: any) => chip.estados!.includes(registro?.[campo]));
};

/** Cuantos registros le corresponden a un chip. */
export const contarPorChip = (
  registros: any[],
  chips: ChipEstado[],
  clave: string | null | undefined,
  campo: string
): number => filtrarPorChip(registros, chips, clave, campo).length;
